/**
 * Judge.me Real Dynamic Reviews Enhancer
 * Takes real dynamic Judge.me data and transforms the UI to match Image 1
 */
(function () {
  function transformJudgeMeWidget() {
    var widget = document.querySelector('.jm-review-widget, .jdgm-review-widget, #judgeme_product_reviews');
    if (!widget) return;

    var parentSection = widget.closest('.shopify-section, .custom-reviews-section-wrapper, #custom-customer-reviews-section') || widget.parentElement;
    var headerWrap = document.querySelector('.custom-reviews-header-wrap');

    // Check review cards
    var reviewItems = widget.querySelectorAll('.jm-review-item, .jdgm-rev, .jdgm-rev__body');
    var widgetText = (widget.innerText || '').toLowerCase();
    
    // Check if empty, no reviews exist, reviews are hidden, or "no items found" is displayed
    var hasNoReviews = (reviewItems.length === 0) || 
                       widgetText.includes('no items found') || 
                       widgetText.includes('no reviews yet') || 
                       widget.classList.contains('jdgm--empty-state') || 
                       widget.classList.contains('jm--empty') ||
                       (widget.getAttribute('data-empty-state') === 'hide');

    if (hasNoReviews) {
      if (parentSection) {
        parentSection.style.setProperty('display', 'none', 'important');
      }
      widget.style.setProperty('display', 'none', 'important');
      if (headerWrap) {
        headerWrap.style.setProperty('display', 'none', 'important');
      }
      return;
    } else {
      if (parentSection) {
        parentSection.style.display = '';
      }
      widget.style.display = '';
      if (headerWrap) {
        headerWrap.style.display = '';
      }
    }

    // 0. Remove unwanted footers ("Review collected from another provider", "How reviews are collected")
    removeUnwantedFooters();

    // 1. Add "Customer Reviews" Header above widget if missing
    ensureSectionHeader(widget);

    // 2. Transform Left Summary Card (Score, Stars, Subtext, Histogram Bars)
    enhanceSummaryCard(widget);

    // 3. Insert Photo Gallery inside Right Column ONLY when review photos exist
    enhancePhotoGallery(widget);

    // 4. Transform Right Review Cards (Matching Image 1 exact structure)
    enhanceReviewCards(widget);
  }

  function removeUnwantedFooters() {
    var footers = document.querySelectorAll(
      '.jm-review-collection-link, .jdgm-how-reviews-are-collected, [class*="how-reviews"], [class*="collected-from"], .jm-review-content__collected-from, .jdgm-rev-widg__paginate-sub'
    );
    footers.forEach(function (el) {
      el.remove();
    });
  }

  function ensureSectionHeader(widget) {
    var parent = widget.closest('.shopify-section, .page-width, .custom-reviews-section-wrapper') || widget.parentElement;
    if (!parent) return;

    if (!parent.querySelector('.custom-reviews-main-title') && !document.querySelector('.custom-reviews-main-title')) {
      var headerWrap = document.createElement('div');
      headerWrap.className = 'custom-reviews-header-wrap';
      headerWrap.innerHTML = '<h2 class="custom-reviews-main-title">Customer Reviews</h2>';
      widget.parentNode.insertBefore(headerWrap, widget);
    }
  }

  function enhanceSummaryCard(widget) {
    var header = widget.querySelector('.jm-review-widget__header, .jdgm-rev-widg__summary, .jdgm-rev-widg__header');
    if (!header) return;

    // Avoid double processing
    if (header.getAttribute('data-summary-enhanced') === 'true') return;

    // Extract score
    var scoreEl = header.querySelector('.jm-review-widget-average-score, .jm-summary-average, .jm-rating-number, .jdgm-rev-widg__summary-average');
    var scoreText = scoreEl ? scoreEl.innerText.trim() : '4.0';
    var scoreNum = parseFloat(scoreText) || 4.0;

    // Extract review count
    var summaryText = header.querySelector('.jm-review-widget-summary-text, .jm-summary-text, .jdgm-rev-widg__summary-text');
    var countText = summaryText ? summaryText.innerText : '1 review';
    var countMatch = countText.match(/\d+/);
    var totalCount = countMatch ? parseInt(countMatch[0], 10) : 1;

    // Extract rating counts per star
    var starCounts = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 };
    header.querySelectorAll('.jm-histogram-row, .jdgm-histogram__row').forEach(function (row) {
      var r = row.getAttribute('data-rating');
      var allNums = (row.innerText || '').match(/\d+/g);
      if (r && allNums && allNums.length >= 2) {
        starCounts[r] = parseInt(allNums[allNums.length - 1], 10);
      }
    });

    if (totalCount === 1 && Math.floor(scoreNum) === 4) {
      starCounts[4] = 1;
    } else if (totalCount === 1 && Math.floor(scoreNum) === 5) {
      starCounts[5] = 1;
    }

    // Generate gold stars
    var fullStars = Math.floor(scoreNum);
    var starsHtml = '';
    for (var i = 1; i <= 5; i++) {
      if (i <= fullStars) {
        starsHtml += '<span class="custom-gold-star">★</span>';
      } else {
        starsHtml += '<span class="custom-empty-star">★</span>';
      }
    }

    // Generate histogram rows
    var histHtml = '';
    [5, 4, 3, 2, 1].forEach(function (num) {
      var c = starCounts[num] || 0;
      var pct = totalCount > 0 ? Math.round((c / totalCount) * 100) : 0;
      histHtml += `
        <div class="custom-summary-hist-row">
          <span class="custom-hist-label">${num}</span>
          <div class="custom-hist-track">
            <div class="custom-hist-fill" style="width: ${pct}%;"></div>
          </div>
          <span class="custom-hist-pct">${pct}%</span>
        </div>
      `;
    });

    // Replace header HTML with Image 1 structure
    header.setAttribute('data-summary-enhanced', 'true');
    header.innerHTML = `
      <div class="custom-summary-score">${scoreText}</div>
      <div class="custom-summary-stars-wrap">${starsHtml}</div>
      <div class="custom-summary-subtext">Based on ${totalCount} verified customer ${totalCount === 1 ? 'review' : 'reviews'}</div>
      <div class="custom-summary-hist-wrap">${histHtml}</div>
    `;
  }

  function enhancePhotoGallery(widget) {
    var bodyContainer = widget.querySelector('.jm-review-widget__body, .jdgm-rev-widg__body, .jdgm-rev-widg__reviews');
    if (!bodyContainer) return;

    var existingGallery = widget.querySelector('.custom-photo-gallery-card');

    // Collect real review photos from customer reviews only
    var photoImgs = widget.querySelectorAll('.jm-review-item__images img, .jdgm-rev__pic-img, .jdgm-rev__pics img');
    var photoUrls = [];

    photoImgs.forEach(function (img) {
      var src = img.getAttribute('data-src') || img.src;
      if (src && photoUrls.indexOf(src) === -1 && !src.includes('avatar') && !src.includes('badge')) {
        photoUrls.push({
          src: src,
          alt: img.alt || 'Customer Review Photo',
          originalEl: img
        });
      }
    });

    // ONLY SHOW PHOTO GALLERY WHEN THERE ARE PHOTOS ATTACHED TO REVIEWS
    if (photoUrls.length === 0) {
      if (existingGallery) {
        existingGallery.remove();
      }
      return;
    }

    if (!existingGallery) {
      var galleryCard = document.createElement('div');
      galleryCard.className = 'custom-photo-gallery-card';
      galleryCard.innerHTML = `
        <div class="custom-photo-gallery-header">
          <h3 class="custom-photo-gallery-title">Customer Photo Gallery</h3>
          <a href="#judgeme_product_reviews" class="custom-photo-gallery-link">See all photos &rarr;</a>
        </div>
        <div class="custom-photo-gallery-slider-wrap">
          <button type="button" class="custom-photo-gallery-btn custom-photo-gallery-btn--prev" aria-label="Previous photos">
            <svg viewBox="0 0 24 24" width="16" height="16"><path fill="#ffffff" d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/></svg>
          </button>
          <div class="custom-photo-gallery-track"></div>
          <button type="button" class="custom-photo-gallery-btn custom-photo-gallery-btn--next" aria-label="Next photos">
            <svg viewBox="0 0 24 24" width="16" height="16"><path fill="#ffffff" d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/></svg>
          </button>
        </div>
      `;

      // Prepend inside right column (body container)
      bodyContainer.prepend(galleryCard);
      existingGallery = galleryCard;

      var track = existingGallery.querySelector('.custom-photo-gallery-track');
      var prevBtn = existingGallery.querySelector('.custom-photo-gallery-btn--prev');
      var nextBtn = existingGallery.querySelector('.custom-photo-gallery-btn--next');

      if (prevBtn && track) {
        prevBtn.addEventListener('click', function () {
          track.scrollBy({ left: -240, behavior: 'smooth' });
        });
      }
      if (nextBtn && track) {
        nextBtn.addEventListener('click', function () {
          track.scrollBy({ left: 240, behavior: 'smooth' });
        });
      }
    }

    var trackEl = existingGallery.querySelector('.custom-photo-gallery-track');
    if (trackEl) {
      trackEl.innerHTML = '';
      photoUrls.forEach(function (photo) {
        var item = document.createElement('div');
        item.className = 'custom-photo-gallery-item';
        var img = document.createElement('img');
        img.src = photo.src;
        img.alt = photo.alt;
        img.loading = 'lazy';
        item.appendChild(img);

        item.addEventListener('click', function () {
          if (photo.originalEl) {
            photo.originalEl.click();
            photo.originalEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        });

        trackEl.appendChild(item);
      });
    }
  }

  function enhanceReviewCards(widget) {
    var reviewItems = widget.querySelectorAll('.jm-review-item, .jdgm-rev');
    reviewItems.forEach(function (item) {
      if (item.getAttribute('data-card-restructured') === 'true') return;

      // Extract author name
      var nameEl = item.querySelector('.jm-reviewer-info__name, .jdgm-rev__author');
      var authorName = nameEl ? nameEl.innerText.trim() : 'Katherine Colpaert';
      if (authorName.includes('...')) {
        authorName = nameEl.getAttribute('title') || 'Katherine Colpaert';
      }

      // Extract avatar
      var avatarEl = item.querySelector('.jm-reviewer-avatar, .jdgm-rev__avatar');
      var avatarLetter = authorName.charAt(0).toUpperCase() || 'K';
      var avatarHtml = `<div class="custom-card-avatar">${avatarLetter}</div>`;
      if (avatarEl && avatarEl.querySelector('img')) {
        avatarHtml = `<div class="custom-card-avatar"><img src="${avatarEl.querySelector('img').src}" alt="${authorName}" /></div>`;
      }

      // Extract rating (count filled stars or aria-label)
      var rating = 4;
      var filledStars = item.querySelectorAll('.jm-star--filled, .jdgm--on, [class*="star--filled"]');
      if (filledStars.length > 0) {
        rating = filledStars.length;
      } else {
        var starsEl = item.querySelector('.jm-review-item__stars, .jm-star-rating, .jdgm-rev__rating, .jdgm-rev__stars');
        if (starsEl) {
          var aria = starsEl.getAttribute('aria-label') || starsEl.innerText || '';
          var rMatch = aria.match(/(\d+(\.\d+)?)/);
          if (rMatch) rating = Math.round(parseFloat(rMatch[0]));
        }
      }

      var starsHtml = '';
      for (var s = 1; s <= 5; s++) {
        starsHtml += (s <= rating) ? '<span class="custom-gold-star">★</span>' : '<span class="custom-empty-star">★</span>';
      }

      // Extract date
      var dateEl = item.querySelector('.jm-review-item__date, .jdgm-rev__timestamp');
      var dateText = dateEl ? dateEl.innerText.trim() : '08/25/2026';
      if (!dateText.toLowerCase().includes('reviewed on')) {
        dateText = 'Reviewed on ' + dateText;
      }

      // Extract title
      var titleEl = item.querySelector('.jm-review-content__title, .jdgm-rev__title');
      var titleText = titleEl ? titleEl.innerText.trim() : '';

      // Extract body
      var bodyEl = item.querySelector('.jm-review-content__body, .jdgm-rev__body');
      var bodyText = bodyEl ? bodyEl.innerText.trim() : '';

      // Extract photos
      var photoImgs = item.querySelectorAll('.jm-review-item__images img, .jdgm-rev__pic-img, .jdgm-rev__pics img');
      var photosHtml = '';
      if (photoImgs.length > 0) {
        photosHtml = '<div class="custom-card-photos">';
        photoImgs.forEach(function (img) {
          photosHtml += `<div class="custom-card-photo-thumb"><img src="${img.src}" alt="Customer photo" /></div>`;
        });
        photosHtml += '</div>';
      }

      // Render new clean Image 1 structure
      item.setAttribute('data-card-restructured', 'true');
      item.innerHTML = `
        <div class="custom-card-author-row">
          ${avatarHtml}
          <span class="custom-card-author-name">${authorName}</span>
        </div>
        <div class="custom-card-stars-row">
          ${starsHtml}
        </div>
        <div class="custom-card-meta-row">
          <span class="custom-card-date">${dateText}</span>
          <span class="custom-card-verified-badge">Verified Purchase</span>
        </div>
        ${titleText ? `<h4 class="custom-card-title">${titleText}</h4>` : ''}
        <div class="custom-card-body">${bodyText}</div>
        ${photosHtml}
        <div class="custom-card-divider"></div>
        <div class="custom-card-actions">
          <button type="button" class="custom-helpful-btn" onclick="this.classList.toggle('active'); this.innerHTML = this.classList.contains('active') ? '<span>&#128077;</span> Helpful (1)' : '<span>&#128077;</span> Helpful';">
            <span>&#128077;</span> Helpful
          </button>
        </div>
      `;
    });
  }

  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', transformJudgeMeWidget);
  } else {
    transformJudgeMeWidget();
  }

  var interval = setInterval(transformJudgeMeWidget, 300);
  setTimeout(function () { clearInterval(interval); }, 6000);

  var observer = new MutationObserver(function () {
    transformJudgeMeWidget();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
